<mat-accordion multi>
  <mat-expansion-panel *ngIf="settings && settings.T4">
    <mat-expansion-panel-header>
      <mat-panel-title>
        {{ 'TO.CustomerSettings.tabGeneral' | translate : 'General' }}
      </mat-panel-title>
      <mat-panel-description>
        {{ 'TO.CustomerSettings.tipGeneral' | translate : 'General settings concerning this customer  ' }}
        <mat-icon>account_circle</mat-icon>
      </mat-panel-description>
    </mat-expansion-panel-header>
    <div class="settings-panel-content">
      <div class="row">
        <div class="col-12 settingsSection">
          <h2>{{ 'TO.CustomerSettings.T4LocationGroup' | translate : 'Location group'}}</h2>
          <mat-form-field>
            <mat-select placeholder="{{ 'TO.CustomerSettings.drpLocationGroup.placeholder' | translate:'LocationGroup'}}" [(ngModel)]="selectedGroup">
              <mat-option *ngFor="let i of groups" [value]="i.Id">{{ i.Name }}</mat-option>
            </mat-select>
          </mat-form-field><br />
          <div>{{ 'TO.CustomerSettings.lblImplicitGroup' | translate : 'Automatic group' }}: {{ implicitGroup }}</div>
        </div>
        <br />
        <mat-slide-toggle [(ngModel)]="settings.OneWay!.OpenForPickup">{{ 'TO.CustomerSettings.tabOneWay.lblOpenForPickup' | translate : 'Open for pickup' }}</mat-slide-toggle>
        <br />
        <mat-slide-toggle [(ngModel)]="settings.T4!.IsUnmanned">{{ 'TO.CustomerSettings.tabOneWay.lblIsUnmanned' | translate : 'Is an unmanned location' : 'Is this customer unmanned' }}</mat-slide-toggle>
        <br />

        <br />
        <mat-form-field appearance="outline">
          <mat-label>{{ 'TO.CustomerSettings.T4ReviewRequestUri' | translate : 'Review link'}}</mat-label>
          <input matInput type="text" required [(ngModel)]="settings.T4!.ReviewRequestUri" />
        </mat-form-field><br />
        <mat-form-field appearance="outline">
          <mat-label>{{ 'TO.CustomerSettings.T4DisplayName' | translate : 'T4 display name'}}</mat-label>
          <input matInput type="text" required [(ngModel)]="settings.T4!.T4DisplayName" />
        </mat-form-field><br /><br />
        <button mat-raised-button color="primary" (click)="saveSettings()">{{ 'TO.CustomerSettings.cmdSave' | translate : 'Save' }}</button>
      </div>
    </div>


  </mat-expansion-panel>

  <mat-expansion-panel *ngIf="settings && settings.OneWay">
    <mat-expansion-panel-header>
      <mat-panel-title>
        OneWay
      </mat-panel-title>
      <mat-panel-description>
        {{ 'TO.CustomerSettings.tipOneWay' | translate : 'Include this customer in the OneWay concept ' }}
        <mat-icon>account_circle</mat-icon>
      </mat-panel-description>
    </mat-expansion-panel-header>
    <div class="settings-panel-content">
      <div class="row">
        <div class="col-12 settingsSection">
          <h2>{{ 'TO.CustomerSettings.tabOneWay.lblOneWayGeneral' | translate : 'General settings' }}</h2>
          <mat-slide-toggle [(ngModel)]="settings.OneWay!.AllowOneWay">{{ 'TO.CustomerSettings.tabOneWay.lblAllowOneWay' | translate : 'OneWay' }}</mat-slide-toggle>
          <ng-container *ngIf="settings.OneWay!.AllowOneWay">
            <br/>
            <mat-slide-toggle [(ngModel)]="settings.OneWay!.AllowSelfService">{{ 'TO.CustomerSettings.tabOneWay.lblAllowOWSelfservice' | translate : 'Allow self service' : 'Are customers allowed to pickup trailers by them self in the app?' }}</mat-slide-toggle>
            <br />
            <label>{{ 'TO.CustomerSettings.tabOneWay.lblPriority' | translate : 'Priority' }}</label>
            <mat-slider min="1" max="15" step="1" [(ngModel)]="settings.OneWay!.Priority" discrete style="width: 250px">
              <input matSliderThumb />
            </mat-slider>
          </ng-container>
        </div>
      </div>

      <div class="row" *ngIf="settings.OneWay!.AllowOneWay">
        <div class="col-6 settingsSection">
          <h2>{{ 'TO.CustomerSettings.tabOneWay.lblTrailerLimits' | translate : 'Trailer limits' }}</h2>
          <br />
          <label>{{ 'TO.CustomerSettings.tabOneWay.lblSoftLimit' | translate : 'Soft limit' }}</label>
          <mat-slider min="5" max="100" step="1" discrete style="width: 250px">
            <input matSliderThumb [(ngModel)]="settings.OneWay!.SoftLimit" />
          </mat-slider>
          <br />
          <label>{{ 'TO.CustomerSettings.tabOneWay.lblHardLimit' | translate : 'Hard limit' }}</label>
          <mat-slider min="5" max="100" step="1" discrete style="width: 250px">
            <input matSliderThumb [(ngModel)]="settings.OneWay!.HardLimit" />
          </mat-slider>
          <br />
          <br />
          <label>{{ 'TO.CustomerSettings.tabOneWay.lblOpeningSettings' | translate : 'Opening Settings' }}</label>
          <br />
          <mat-slide-toggle [(ngModel)]="settings.OneWay!.OverrideLockStatus">{{ 'TO.CustomerSettings.tabOneWay.lblOverrideLock' | translate : 'Override lock' }}</mat-slide-toggle>
          <br />
          <mat-slide-toggle [(ngModel)]="settings.OneWay!.OpenForPickup" [disabled]="!settings.OneWay!.OverrideLockStatus">{{ 'TO.CustomerSettings.tabOneWay.lblOpenForPickup' | translate : 'Open for pickup' }}</mat-slide-toggle>
          <br />
          <mat-slide-toggle [(ngModel)]="settings.OneWay!.OpenForReturn" [disabled]="!settings.OneWay!.OverrideLockStatus">{{ 'TO.CustomerSettings.tabOneWay.lblOpenForReturn' | translate : 'Open for return' }}</mat-slide-toggle>
          <br />
          <mat-form-field appearance="outline">
            <mat-label>{{ 'TO.CustomerSettings.tabOneWay.lblClosingReason' | translate : 'Closing reason' }}</mat-label>
            <input matInput type="text" [disabled]="!settings.OneWay!.OverrideLockStatus" [(ngModel)]="settings.OneWay!.ClosedReason" />
          </mat-form-field>

        </div>
      </div>
      <button mat-raised-button color="primary" (click)="saveSettings()">{{ 'TO.CustomerSettings.cmdSave' | translate : 'Save' }}</button>
    </div>
  </mat-expansion-panel>

  <mat-expansion-panel *ngIf="settings && settings.Service">
    <mat-expansion-panel-header>
      <mat-panel-title>
        {{ 'TO.CustomerSettings.pnlService' | translate : 'Service' }}
      </mat-panel-title>
      <mat-panel-description>
        {{ 'TO.CustomerSettings.tipService' | translate : 'Settings regarding service agreements ' }}
        <mat-icon>handyman</mat-icon>
      </mat-panel-description>
    </mat-expansion-panel-header>

    <div class="settings-panel-content service-settings-panel">
      <div class="service-settings-grid">
        <section class="service-settings-column">
          <h2>{{ 'TO.CustomerSettings.tabService.lblServicePartner' | translate : 'Partner settings' }}</h2>
          <div class="service-settings-column-content service-settings-column-content-compact">
            <mat-slide-toggle [(ngModel)]="settings.Service!.IsServicePartner">{{ 'TO.CustomerSettings.tabService.lblIsServicePartner' | translate : 'Is service partner' }}</mat-slide-toggle>
            <mat-form-field appearance="outline">
              <mat-label>{{ 'TO.CustomerSettings.tabService.lblRequestEmail' | translate : 'Service request email' }}</mat-label>
              <input matInput type="text" required [(ngModel)]="settings.Service!.RequestEmail" />
            </mat-form-field>
          </div>
        </section>

        <section class="service-settings-column">
          <h2>{{ 'TO.CustomerSettings.tabService.lblService' | translate : 'Service routing' }}</h2>
          <div class="service-settings-column-content">
            <mat-form-field appearance="outline">
              <mat-label>{{ 'TO.CustomerSettings.tabService.txtServicePartner' | translate : 'Service partner' }}</mat-label>
              <mat-select [(ngModel)]="settings.Service!.ServicePartnerId" (ngModelChange)="onServicePartnerChanged($event)">
                <mat-option *ngFor="let partner of servicePartners" [value]="partner.Id">{{ partner.Name }}</mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field appearance="outline">
              <mat-label>{{ 'TO.CustomerSettings.tabService.txtUsedPartner' | translate : 'Used partner' }}</mat-label>
              <mat-select [(ngModel)]="settings.Service!.UsedPartner">
                <mat-option *ngFor="let partner of servicePartners" [value]="partner.Id">{{ partner.Name }}</mat-option>
              </mat-select>
              <button mat-icon-button matSuffix type="button" *ngIf="settings.Service!.UsedPartner" (click)="settings.Service!.UsedPartner = undefined">
                <mat-icon>clear</mat-icon>
              </button>
            </mat-form-field>
          </div>
        </section>

        <section class="service-settings-column">
          <h2>{{ 'TO.CustomerSettings.tabOneWay.lblRepairs' | translate : 'Repairs' }}</h2>
          <div class="service-settings-column-content">
            <mat-form-field appearance="outline">
              <mat-label>{{ 'TO.CustomerSettings.tabService.txtRepairPartner' | translate : 'Repair partner' }}</mat-label>
              <input matInput type="text" required [(ngModel)]="settings.Service!.RepairPartnerId" />
              <button mat-icon-button matSuffix (click)="selectPartner()">
                <mat-icon>edit</mat-icon>
              </button>
            </mat-form-field>
            <div class="service-settings-slider">
              <label>{{ 'TO.CustomerSettings.tabOneWay.lblServiceZone' | translate : 'Zone' }}</label>
              <mat-slider min="1" max="3" step="1" discrete>
                <input matSliderThumb [(ngModel)]="settings.Service!.ServiceZone" />
              </mat-slider>
            </div>
          </div>
        </section>
      </div>

      <div class="service-settings-footer">
        <button class="service-settings-save" mat-raised-button color="primary" (click)="saveSettings()">{{ 'TO.CustomerSettings.cmdSave' | translate : 'Save' }}</button>
      </div>
    </div>
  </mat-expansion-panel>

  <mat-expansion-panel *ngIf="settings && settings.Payment">
    <mat-expansion-panel-header>
      <mat-panel-title>
        Payment
      </mat-panel-title>
      <mat-panel-description>
        {{ 'TO.CustomerSettings.tooltipPaythrough' | translate : 'Paythough settings for this customer' }}
        <mat-icon>payments</mat-icon>
      </mat-panel-description>
    </mat-expansion-panel-header>
    <div class="settings-panel-content">
      <div class="row">
        <div class="col-6 settingsSection">
          <h2>Paythrough</h2>

          <mat-from-field>
            <mat-slide-toggle [(ngModel)]="settings.Payment.UsingPaythrough">Using Paythrough</mat-slide-toggle>
          </mat-from-field>

          <br />

          <mat-form-field appearance="outline">
            <mat-label>Invoice Email</mat-label>
            <input matInput type="text" [(ngModel)]="settings.Payment.InvoiceEmail" [disabled]="!settings.Payment.UsingPaythrough"/>
          </mat-form-field>


          <mat-form-field appearance="outline">
            <mat-label>Supplier Account</mat-label>
            <input matInput type="text"  [(ngModel)]="settings.Payment.SupplierAccount" [disabled]="!settings.Payment.UsingPaythrough"/>
          </mat-form-field>

        </div>
        <div class="col-6 settingsSection">
          <h2>Payout Info</h2>

          <form [formGroup]="form">
            <div formArrayName="payouts">
              <div *ngFor="let payout of payouts.controls; let i = index" [formGroupName]="i" class="row">
                <div class="col-2">
                  <mat-form-field appearance="outline">
                    <mat-label>Type</mat-label>
                    <select matNativeControl formControlName="type" [disabled]="!settings.Payment.UsingPaythrough">
                      <option *ngFor="let option of getAvailableOptions(payout.get('type')?.value)" [value]="option">
                        {{ option }}
                      </option>
                    </select>
                  </mat-form-field>
                </div>
                <div class="col">
                  <mat-form-field appearance="outline">
                    <mat-label>Payout Info</mat-label>
                    <input matInput type="text" formControlName="payoutInfo" [disabled]="!settings.Payment.UsingPaythrough"/>
                  </mat-form-field>
                </div>
                <button mat-icon-button color="warn" (click)="removeInput(i)">
                  <mat-icon>delete</mat-icon>
                </button>
              </div>
            </div>

            <button mat-raised-button color="primary" (click)="addInput()" [disabled]="!settings.Payment.UsingPaythrough">
              Add <mat-icon>add</mat-icon>
            </button>
          </form>
        </div>
      </div>
      <button mat-raised-button color="primary" [disabled]="isSaveDisabled()" (click)="saveSettings()">{{ 'TO.CustomerSettings.cmdSave' | translate : 'Save' }}</button>
    </div>
  </mat-expansion-panel>

</mat-accordion>
